<div class="container" fxLayout="column" fxLayoutAlign="start stretch">
  <mat-card-header class="heading">Update Image Details</mat-card-header>
  <div class="image-preview">
    <img [src]="selectedImage.image_url" alt="Image" class="uploaded-image">
  </div>
  <div class="image-detail">
    <div fxLayout="row wrap" fxLayoutGap="30">
      <div fxLayout="column" fxFlex="55">
        <mat-card-header>Image Title</mat-card-header><br>
        <input type="text" [placeholder]="selectedImage.language === 'fr' ? 'Enter the Image Title in French' : 'Enter the Image Title in English'" class="title-input" [(ngModel)]="selectedImage.title" (ngModelChange)="handleInputChange('title', $event)" [disabled]="selectedImage.image_type === 'banner'"/>
      </div>

      <div fxLayout="column" fxFlex="40">
        <mat-card-header>Image Type</mat-card-header><br>
        <mat-form-field appearance="outline">
          <mat-select placeholder="Select Image Type" [(ngModel)]="selectedImage.image_type" disabled>
            <mat-option value="banner">Banner</mat-option>
            <mat-option value="explorer">Explorer</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div fxLayout="row wrap" fxLayoutGap="30">
      <div fxLayout="column" fxFlex="55">
        <mat-card-header>Image Description</mat-card-header><br>
        <input type="text" [placeholder]="selectedImage.language === 'fr' ? 'Enter the Image Description in French' : 'Enter the Image Description in English'" class="description-input" [(ngModel)]="selectedImage.description" (ngModelChange)="handleInputChange('description', $event)" [disabled]="selectedImage.image_type === 'banner'">
      </div>

      <div fxLayout="column" fxFlex="40">
        <mat-card-header>Language</mat-card-header><br>
        <mat-form-field appearance="outline">
          <mat-select placeholder="Select Language" [(ngModel)]="selectedImage.language" disabled>
            <mat-option value="en">English</mat-option>
            <mat-option value="fr">French</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div fxLayout="row wrap" fxLayoutGap="30" class="date-time-container">
      <div fxLayout="column" fxFlex="55">
        <mat-card-header>Start Date</mat-card-header><br>
        <input type="datetime-local" class="date-input" [(ngModel)]="selectedImage.start_date" (ngModelChange)="handleInputChange('start_date', $event)" [min]="minDate">
      </div>
    
      <div fxLayout="column" fxFlex="40">
        <mat-card-header>End Date</mat-card-header><br>
        <input type="datetime-local" class="date-input" [(ngModel)]="selectedImage.end_date" (ngModelChange)="handleInputChange('end_date', $event)" [min]="selectedImage.start_date">
      </div>
    </div>
    <div *ngIf="dateError" class="error-message">{{ dateError }}</div>    

    <div fxLayout="row wrap" fxLayoutGap="30">
      <div fxLayout="column" fxFlex="55" >
        <mat-card-header>Redirect Link</mat-card-header><br>
        <input type="url" placeholder="Enter URL" class="url-input" [(ngModel)]="selectedImage.read_more_link" (ngModelChange)="handleInputChange('read_more_link', $event)">
        <div *ngIf="redirectLinkError" class="error-message">{{ redirectLinkError }}</div>
      </div>

        <div fxLayout="column" fxFlex="40">
        <mat-card-header>Button Text</mat-card-header><br>
        <input type="text" [placeholder]="selectedImage.language === 'fr' ? 'Enter the Button Text in French' : 'Enter the Button Text in English'" class="button-input" [(ngModel)]="selectedImage.button_text" (ngModelChange)="handleInputChange('button_text', $event)" [disabled]="selectedImage.image_type === 'banner'">
      </div>
    </div>

    <div *ngIf="errorMessage" class="error-message">
      {{ errorMessage }}
    </div>

    <div class="button-group" fxLayout="row" fxLayoutAlign="end">
      <button type="button" class="cancel-button" mat-raised-button (click)="cancel()">Cancel</button>
      <button type="submit" class="edit-button" mat-raised-button (click)="onUpdate()">Update</button>
    </div>
  </div>
</div>